import { SelectItem } from "types/Common";
import { IResume } from "types/package";

export const GetTotal = (resume: IResume): number =>
  resume.tourAmount + resume.hotelAmount + resume.additionalCharges - resume.discount;

export const RemoveDuplicateItems = (options: SelectItem[]) => {
  return options.filter((item, i) => options.findIndex(v => v.value === item.value) === i);
};
